import "./button.css";

function ClearButton(props) {
    const { clear } = props;

    return (
        <>
            <button className="btn btn--primary" onClick={clear}>
                <span>Clear</span>
            </button>            
        </>
    );
};

export default ClearButton;